import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';
import { ToolbarButton } from './Toolbar.style';

export const OutlinedArea = styled('div')`
  display: flex;
  flex-direction: column;
  > :last-child {
    border-bottom: none;
  }
`;

export const ActionItem = styled('div')`
  cursor: pointer;
  display: flex;

  span {
    height: 17px;
    width: 17px;
  }

  svg path {
    stroke: ${colours.neutral[700]};
  }
`;

export const Header = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 5px;
  margin: 10px 0;
  width: fit-content;

  span {
    height: 17px;
    width: 17px;
  }

  svg path {
    stroke: ${colours.neutral[700]};
  }
`;

export const MenuSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 15px 0 15px 30px;
  position: relative;
`;

export const MenuIcon = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  margin-left: 20px;
  opacity: 0.7;
  position: absolute;
  right: 0;
  top: -33px;
`;

export const NumberedContent = styled('div')`
  display: flex;
  flex: 1;
  gap: 10px;
`;

export const NumberBox = styled('div')`
  align-items: center;
  background-color: #ffdbdc;
  border-radius: 30px;
  display: flex;
  height: 17px;
  justify-content: center;
  margin-top: 3px;
  width: 17px;
`;

export const Number = styled(Text.P1Semibold)`
  color: ${colours.primary[700]};
  font-size: 12px;
`;

export const Content = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 10px;
`;

export const List = styled('ul')`
  color: black;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  gap: 10px;
  margin: 15px 0;
  padding-inline-start: 30px;
`;

export const BackButton = styled(ToolbarButton)`
  padding-right: 18px;
  background-color: ${colours.neutral[100]};
  color: black;
  :hover {
    background-color: ${colours.neutral[200]};
  }
`;
